var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2787F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0028 8.54436C19.1042 8.22709 19.0028 7.99396 18.5201 7.99396H16.9239C16.518 7.99396 16.3309 8.19535 16.2294 8.41742C16.2294 8.41742 15.4177 10.2734 14.2678 11.479C13.8958 11.828 13.7267 11.939 13.5238 11.939C13.4223 11.939 13.2754 11.828 13.2754 11.5107V8.54436C13.2754 8.16364 13.1576 7.99396 12.8194 7.99396H10.3111C10.0575 7.99396 9.90495 8.17066 9.90495 8.33813C9.90495 8.69904 10.4799 8.78227 10.5391 9.79753V12.0025C10.5391 12.4859 10.4461 12.5736 10.2431 12.5736C9.70202 12.5736 8.38576 10.7093 7.60509 8.57607C7.4521 8.16144 7.29865 7.99396 6.89071 7.99396H5.29452C4.83847 7.99396 4.74725 8.19535 4.74725 8.41742C4.74725 8.81401 5.2884 10.781 7.2669 13.3826C8.5859 15.1592 10.4443 16.1223 12.1353 16.1223C13.1499 16.1223 13.2755 15.9084 13.2755 15.54V14.1972C13.2755 13.7694 13.3716 13.684 13.6929 13.684C13.9296 13.684 14.3355 13.795 15.2825 14.6516C16.3647 15.6669 16.5432 16.1223 17.1519 16.1223H18.7481C19.2042 16.1223 19.4322 15.9084 19.3006 15.4863C19.1567 15.0656 18.64 14.4552 17.9543 13.7316C17.5823 13.3191 17.0242 12.875 16.8551 12.6529C16.6184 12.3674 16.686 12.2404 16.8551 11.9866C16.8551 11.9866 18.7998 9.41681 19.0028 8.54436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.8a7540e636a50b4047c5ab5584054934.svg";
export { ForwardRef as ReactComponent };